// extracted by mini-css-extract-plugin
export var active = "_8g-b";
export var activeIndicator = "_8g-6";
export var animate = "_8g-a";
export var disabled = "_8g-c";
export var flat = "_8g-1";
export var fullWidth = "_8g-3";
export var lg = "_8g-9";
export var md = "_8g-8";
export var redoButtonTabGroup = "_8g-0";
export var sm = "_8g-7";
export var tabButton = "_8g-4";
export var tabButtonsContainer = "_8g-2";
export var xs = "_8g-5";